<template lang="pug">
transition(
v-on:enter="enter"
v-on:leave="leave"
)
  .scene-trans
    .blank
    .counter(@click="next")
      svg(viewBox="0 0 50 85" fill="none" xmlns="http://www.w3.org/2000/svg")
        use(:class="{'show': counter===0}" xlink:href="#number-0")
        use(:class="{'show': counter===1}" xlink:href="#number-1")
        use(:class="{'show': counter===2}" xlink:href="#number-2")
        use(:class="{'show': counter===3}" xlink:href="#number-3")
        use(:class="{'show': counter===4}" xlink:href="#number-4")
        use(:class="{'show': counter===5}" xlink:href="#number-5")
        use(:class="{'show': counter===6}" xlink:href="#number-6")
        use(:class="{'show': counter===7}" xlink:href="#number-7")
        use(:class="{'show': counter===8}" xlink:href="#number-8")
        use(:class="{'show': counter===9}" xlink:href="#number-9")
      .copy
        .line 下一个
        .line 故事
    .btns(ref="btns")
      .button.follow(@click="follow")
        svg.frame(width="100%" viewBox="0 0 130 20" xmlns="http://www.w3.org/2000/svg")
          rect(:x="`${56-timeline*55}`" y="1" :width="`${18+timeline*110}`" height="18" rx="9" ry="9" fill="none" stroke="white" stroke-width="1")
        .content(:style="`transform: translate3d(${-250*timeline}%, 0, 0);`")
          svg.icon.i-follow
            use(xlink:href="#icon-follow")
          .cp
            .line(:style="`transform: translate3d(${-100*(1-timeline)}%, 0, 0);`") 关注我们
      .button.replay(@click="replay")
        svg.frame(width="100%" viewBox="0 0 130 20" xmlns="http://www.w3.org/2000/svg")
          rect(:x="`${56-timeline2*55}`" y="1" :width="`${18+timeline2*110}`" height="18" rx="9" ry="9" fill="none" stroke="white" stroke-width="1")
        .content(:style="`transform: translate3d(${-250*timeline2}%, 0, 0);`")
          svg.icon.i-replay
            use(xlink:href="#icon-replay")
          .cp
            .line(:style="`transform: translate3d(${-100*(1-timeline2)}%, 0, 0);`") 再看一遍

</template>

<script>
  import * as MODES from 'src/config/modes'
  import { mapState, mapMutations } from 'vuex'
  import AnalyticsService from '@/services/AnalyticsService'
export default {
  name: 'scene-trans',
  props: {
    progress: {
      //required: true,
      default: 0,
    },
  },
  components: {},
  data() {
    return {
      counter: 5,
      timeline: 0,
      timeline2: 0
    }
  },
  computed: {
    ...mapState('app', ['showQRPage', 'mode', 'currSceneIdx']),
    tens(){
      //console.log(Math.floor(this.progress/10))
      return Math.floor(this.progress/10)%10

    },
    single(){
      console.log(this.progress%10)
      return this.progress%10
    }
  },
  beforeMount(){
    this.lockMode()
  },
  mounted() {
    this.t = `sceneEnd-0${this.currSceneIdx+1}-${this.mode === MODES.KIDS? 'kids': 'adults'}`
    this.setCounter()
  },
  beforeDestroy() {
    this.unlockMode()
  },
  methods: {
    ...mapMutations('app', ['openQRPage', 'lockMode', 'unlockMode']),
    setCounter(){
      this.interval = setInterval(() => {
        if (this.counter === 0) {
          clearInterval(this.interval)
          this.next()
        }else{
          this.counter--
        }
      }, 1000)
    },
    next(){
      this.$emit('next')
    },
    follow(){

      AnalyticsService.sendEvent(this.t, 'click', `button-follow`)
      clearInterval(this.interval)
      this.openQRPage()
    },
    replay(){
      AnalyticsService.sendEvent(this.t, 'click', `button-replay`)
      this.$emit('replay')
      
    },

    animateIn(cb) {

      let tl = new TimelineMax({ onComplete: () => {
          cb()
        }})
      this.tl = tl

      tl.add('start')
        .set(
          this,
          {
            timeline: 0,
          },
          `start+=0`
        )
        .set(
          this,
          {
            timeline2: 0,
          },
          `start+=0`
        )
        .set(
          this.$refs.btns.childNodes[0],
          {
            y: 100,
            opacity: 0,
          },
          `start+=0`
        )
        .set(
          this.$refs.btns.childNodes[1],
          {
            y: 100,
            opacity: 0,
          },
          `start+=0`
        )
        .to(
          this.$refs.btns.childNodes[0],
          0.7,
          {
            y: 0,
            opacity: 1,
            ease: Back.easeOut.config(3)
          },
          `start+=0`
        )
        .to(
          this.$refs.btns.childNodes[1],
          0.7,
          {
            y: 0,
            opacity: 1,
            ease: Back.easeOut.config(3)
          },
          `start+=0.2`
        )
        .to(
          this,
          0.7,
          {
            timeline: 1,
            ease: Power2.easeOut
          },
          `start+=0.8`
          )
        .to(
          this,
          0.7,
          {
            timeline2: 1,
            ease: Power2.easeOut
          },
          `start+=0.9`
        )

    },
    enter(el, done){
      this.animateIn(done)

    },
    leave(el, done){
      //this.tl.eventCallback('onReverseComplete', done)
      //console.log(this.tl)
      //this.tl.reverse()
      done()

    },
  },
  watch: {
    showQRPage(val){
      if (!val){
        this.setCounter()
      }
    }
  },
}
</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"

.scene-trans
  pointer-events: all
  +full()
  display: flex
  justify-content: space-around
  align-items: center
  flex-direction: column
  background: rgba(0, 0, 0, 0.3)
  .blank
    width: 100%
    height: 1rem
    //background: #3a54a2
  .counter
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
    svg
      width: 0.5rem
      margin-bottom: 0.2rem
      use
        opacity: 0
        &.show
          opacity: 1
    .copy
      font-size: $fs-m
      color: white
      text-align: center
      .line

    //background: #e15125
  //.btns
    width: auto
    line-height: 0
    //background: #ffd81b
    //.follow
      margin-bottom: 0.2rem
    svg
      padding: 0.08rem
      width: 0.5rem
      height: 0.5rem
      border-radius: 0.25rem
      border: #fff 2px solid
      display: block
      margin-bottom: 0.2rem


      //background: #3a602e
  .btns
    width: 100%
    position: relative
    //background: #f8deb1
    //line-height: 0
    //display: flex
    //justify-content: center
    //align-items: center
    //flex-direction: column
    z-index: 750
    //height: 1.5rem
    .button

      pointer-events: all

      //background: #ff55ac
      line-height: 0
      height: $fs-s*2.5
      color: $cl-lightGold
      font-size: $fs-s
      display: flex
      flex-direction: row
      justify-content: center
      align-items: center

      text-align: center
      margin: 0.25rem auto
      //width: 60%
      width: 3rem
      //border: white 2px solid
      .frame
        position: absolute
        top: -10%
        left: 0
      .content
        position: relative
        //background: #3a602e

        .icon
          width: $fs-m
          height: $fs-m
        //background: #e15125
        //margin-right: 0.1rem
        .i-follow
          transform: scale(1.1) translateY(1px)
          transform-origin: center
        .i-replay
          transform: scale(1.25)
          transform-origin: center
        .cp
          position: absolute
          width: $fs-m*5
          top: -$fs-m/2
          left: 0.25rem
          //background: black
          line-height: $fs-m*2
          height: $fs-m*2
          white-space: nowrap
          overflow: hidden
  //.btns
    width: 100%
    //line-height: 0
    //display: flex
    //justify-content: center
    //align-items: center
    //flex-direction: column
    z-index: 750
    //height: 1.5rem
    .button

      pointer-events: all
      color: $cl-lightGold
      font-size: $fs-s
      line-height: $fs-s*2.5
      //background: #3a54a2
      display: flex
      flex-direction: row
      justify-content: center
      align-items: center
      border-radius: $fs-s*1.5
      text-align: center
      margin: 0.25rem auto
      //width: 60%
      //width: 2rem*0.22
      border: white 2px solid

      svg
        width: $fs-m
        height: $fs-m
        margin-right: 0.1rem
      span
        white-space: nowrap
        overflow: hidden




</style>
